export default __webpack_public_path__ + "static/media/test_token.f52809d3.png";